import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button, Divider } from "@bookips/sds";
import { motion } from "framer-motion";
import Link from "next/link";
import CategorySectionComponent from "./components/CategorySection";
import ShortcutList from "./components/ShortcutList";
import SubjectList from "./components/SubjectList";
import { useCategoryMenu } from "./hooks/useCategoryMenu";
const CategoryMenuDesktop = ()=>{
    const { isOpen , selectedMenuId , menus , selectedMenu , categoryColumns , menuFooter , handleSubjectClick , handleItemClick , handleClose  } = useCategoryMenu();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                initial: false,
                animate: {
                    opacity: isOpen ? 1 : 0
                },
                transition: {
                    duration: 0.15
                },
                className: cn("fixed top-[120px] right-0 bottom-0 left-0 bg-black/30", isOpen ? "z-[799]" : "pointer-events-none -z-10"),
                onClick: handleClose,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ _jsxs("div", {
                onMouseLeave: handleClose,
                className: cn("pointer-events-none fixed top-[72px] right-0 left-0", isOpen ? "z-[800]" : "-z-10"),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex h-[48px] justify-center",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "w-full max-w-[1200px] max-lg:px-8 max-sm:px-5",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: cn("h-full w-[100px] cursor-pointer", isOpen && "pointer-events-auto"),
                                onClick: ()=>{
                                    mixpanelEvent("GNB Button Clicked", {
                                        "button type": "category",
                                        "button name": "카테고리",
                                        "action type": "click/tap"
                                    });
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(motion.div, {
                        initial: false,
                        animate: {
                            opacity: isOpen ? 1 : 0,
                            y: isOpen ? 0 : -8
                        },
                        transition: {
                            duration: 0.15,
                            ease: "easeOut"
                        },
                        className: cn("w-full bg-white", // 하단 48px 여백 + 카테고리 메뉴판 footer 48px = 96px 확보
                        "max-h-[calc(100vh-120px-96px)]", "flex flex-col", isOpen && "pointer-events-auto border-t border-gray-100"),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex h-[560px] min-h-0 shrink flex-col",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mx-auto flex min-h-0 w-full max-w-[1200px] flex-1",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex w-[120px] shrink-0 flex-col bg-gray-50",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "custom-scrollbar flex-1 overflow-y-auto",
                                                children: /*#__PURE__*/ _jsx(SubjectList, {
                                                    items: menus,
                                                    selectedId: selectedMenuId,
                                                    onItemClick: handleSubjectClick
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex min-w-0 flex-1 flex-col",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex min-h-0 min-w-0 flex-1",
                                                    children: categoryColumns.map((section)=>/*#__PURE__*/ _jsx("div", {
                                                            className: cn("custom-scrollbar h-full flex-1 overflow-y-auto", "border-r border-gray-100"),
                                                            children: section.groups.map((group, index)=>/*#__PURE__*/ _jsxs("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(CategorySectionComponent, {
                                                                            title: group.groupTitle,
                                                                            titleLink: group.groupLink,
                                                                            items: group.items,
                                                                            onItemClick: handleItemClick
                                                                        }),
                                                                        index < section.groups.length - 1 && /*#__PURE__*/ _jsx(Divider, {
                                                                            className: "border-gray-100"
                                                                        })
                                                                    ]
                                                                }, group.groupSeq))
                                                        }, section.sectionNumber))
                                                }),
                                                (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.ctaButtonUrl) && (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.ctaButtonTitle) && /*#__PURE__*/ _jsx("div", {
                                                    className: "shrink-0 border-r border-gray-100 px-5 py-3",
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        href: selectedMenu.ctaButtonUrl,
                                                        onClick: ()=>{
                                                            mixpanelEvent("Category Board Item Clicked", {
                                                                "Item Type": "CTA Button",
                                                                "Item Name": selectedMenu.ctaButtonTitle
                                                            });
                                                            handleClose();
                                                        },
                                                        className: "block",
                                                        children: /*#__PURE__*/ _jsx(Button, {
                                                            variant: "stroke",
                                                            color: "secondary",
                                                            size: "md",
                                                            className: "w-full",
                                                            children: selectedMenu.ctaButtonTitle
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "shrink-0",
                                children: /*#__PURE__*/ _jsx(ShortcutList, {
                                    items: menuFooter,
                                    onItemClick: handleClose
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default CategoryMenuDesktop;
